import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Calendar } from 'lucide-react';

const WineSettingsTab = () => {
  const [settings, setSettings] = useState({
    toppingIntervalRed: 30,
    toppingIntervalWhite: 21,
    toppingWarningDays: 5,
    enableAutomaticTagging: true
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get('/api/settings/topping');
        if (response.data) {
          setSettings(response.data);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching settings:', error);
        setError('Failed to load settings');
        setLoading(false);
      }
    };
    
    fetchSettings();
  }, []);
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings({
      ...settings,
      [name]: type === 'checkbox' ? checked : parseInt(value)
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setError(null);
    
    try {
      await axios.post('/api/settings/topping', settings);
      setSuccess(true);
    } catch (error) {
      console.error('Error saving settings:', error);
      setError('Failed to save settings');
    }
  };
  
  if (loading) return <div className="spinner-border text-primary" role="status"></div>;
  
  return (
    <div>
      <h5 className="mb-3"><Calendar className="me-2" />Wine Maintenance Settings</h5>
      
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">Settings saved successfully!</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="card mb-4">
          <div className="card-header">
            <h5 className="mb-0">Topping Schedule</h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Red Wine Topping Interval (days)</label>
                <input
                  type="number"
                  className="form-control"
                  name="toppingIntervalRed"
                  value={settings.toppingIntervalRed}
                  onChange={handleChange}
                  min="1"
                  max="90"
                />
                <div className="form-text">
                  How often red wines should be topped
                </div>
              </div>
              
              <div className="col-md-6 mb-3">
                <label className="form-label">White Wine Topping Interval (days)</label>
                <input
                  type="number"
                  className="form-control"
                  name="toppingIntervalWhite"
                  value={settings.toppingIntervalWhite}
                  onChange={handleChange}
                  min="1"
                  max="90"
                />
                <div className="form-text">
                  How often white wines should be topped
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Warning Days Before Due</label>
                <input
                  type="number"
                  className="form-control"
                  name="toppingWarningDays"
                  value={settings.toppingWarningDays}
                  onChange={handleChange}
                  min="1"
                  max="30"
                />
                <div className="form-text">
                  Days before due date to show warning status
                </div>
              </div>
              
              <div className="col-md-6 mb-3">
                <div className="form-check form-switch mt-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="enableAutomaticTagging"
                    checked={settings.enableAutomaticTagging}
                    onChange={handleChange}
                    id="enableTagging"
                  />
                  <label className="form-check-label" htmlFor="enableTagging">
                    Enable automatic tagging
                  </label>
                </div>
                <div className="form-text">
                  Automatically tag wines that need topping
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <button type="submit" className="btn btn-primary">
          Save Settings
        </button>
      </form>
    </div>
  );
};

export default WineSettingsTab;